import React, { useRef } from "react";
import sense from "../Assets/imgs/sense.webp";
import sales from "../Assets/imgs/sales.webp";
import easywebinar from "../Assets/imgs/easywebinar.webp";
import hubspot from "../Assets/imgs/hubspot.webp";
import chili from "../Assets/imgs/chili.webp";
import zoom from "../Assets/imgs/zoom.webp";
import shuffleBrn from "../Assets/imgs/shuffleBtn.webp";
import gsap from "gsap";
import { shuffleLogos } from "../utils/GSAPFunctions";

const LandScape = () => {
  const shuffleContainerRef = useRef<HTMLDivElement>(null);

  const handleShuffle = () => {
    if (shuffleContainerRef.current) {
      shuffleLogos(shuffleContainerRef.current);
    }
  };

  return (
    <>
      <div className="__landScape">
        <div className="container-fluid">
          <div className="__landScapeWraper">
            <div className="row __rowReverse">
              <div className="col-lg-7 col-md-12 col-12">
                <div className="__logsColumn" ref={shuffleContainerRef}>
                  <button className="__shuffleBtn" onClick={handleShuffle}>
                    <img src={shuffleBrn} alt="btn" className="shuffleImg" />
                  </button>
                  {/* logo items here */}
                  {[
                    sense,
                    sales,
                    easywebinar,
                    hubspot,
                    chili,
                    zoom,
                    zoom,
                    chili,
                    hubspot,
                    easywebinar,
                    sales,
                    sense,
                  ].map((img, i) => (
                    <div
                      className={`__singleLogoCol ${i < 6 ? "active" : ""}`}
                      key={i}
                    >
                      <img src={img} alt={`logo-${i}`} />
                    </div>
                  ))}
                </div>
              </div>
              <div className="col-lg-5 col-md-12 col-12">
                <div className="__masterInSaas">
                  <div className="__blueHeading">
                    Masters in your sass landscape
                  </div>
                  <div className="__shortDesc">
                    We integrate seamlessly with your platforms and team,
                    crafting revenue-boosting strategies that continue to
                    benefit your company long-term.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LandScape;
